import styled from "@emotion/styled"
import { Dialog, Button } from "@blueprintjs/core"
import { FlexContainer } from "../../../../../styled/flexbox.styled"
import { MediumText } from "../../../../../styled/text.styled"

export const StyledDialog = styled(Dialog)({
  width: "500px",
})

export const DialogContent = styled(FlexContainer)({
  padding: "20px",
})

export const MainContainer = styled(FlexContainer)({
  flexDirection: "column",
  gap: "20px",
  width: "100%",
})

export const HeaderText = styled(MediumText)({
  marginBottom: "10px",
})

export const SubHeaderText = styled(MediumText)({
  fontSize: "12px",
  color: "#666",
  marginBottom: "10px",
})

export const TemplateButton = styled(Button)({
  marginBottom: "10px",
})

export const ButtonContainer = styled(FlexContainer)({
  gap: "10px",
  justifyContent: "flex-end",
})

export const UploadButtonContent = styled(FlexContainer)({
  gap: "5px",
  alignItems: "center",
})

export const OverwriteContainer = styled(FlexContainer)({
  flexDirection: "column",
  gap: "8px",
  padding: "12px",
  backgroundColor: "#2d3748",
  borderRadius: "4px",
  border: "1px solid #4a5568",
})

export const WarningText = styled(MediumText)({
  fontSize: "12px",
  color: "#f6ad55",
  lineHeight: "1.4",
})
